import { useEffect, useState } from 'react';
import { resolveBlock } from '../api/transactions';

export function useResolvedBlock(query) {
  const [resolved, setResolved] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const normalized = String(query || '').trim();
    if (!/^(0x[0-9a-fA-F]+|[0-9]+)$/.test(normalized)) {
      setLoading(false);
      setError('Invalid block number or slot.');
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);
    setResolved(null);

    resolveBlock(normalized)
      .then((result) => {
        if (!cancelled) {
          setResolved(result);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.response?.data?.message || err.message || 'Block not found.');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [query]);

  return { resolved, loading, error };
}
